/**
 * O contrato OpenAPI atual (artifacts/openapi/v1.json) descreve apenas os request bodies
 * (RegisterRequest/LoginRequest/CreateTenantRequest via components.schemas): os endpoints da
 * Api nao anotam `.Produces<T>()`, entao o documento nao inclui o formato das respostas de
 * sucesso. Os tipos abaixo espelham exatamente os records C# que produzem essas respostas
 * (src/Codout.Support.Api/Endpoints/AuthEndpoints.cs e TenantEndpoints.cs) e sao validados em
 * runtime a partir de `unknown` — nunca um `any`/cast cego. Quando o WP-03 anotar as respostas
 * no OpenAPI, estes tipos podem voltar a ser gerados e este arquivo pode ser removido.
 */

export interface UserResponse {
  readonly id: string
  readonly email: string
  readonly displayName: string
}

export interface TenantResponse {
  readonly id: string
  readonly name: string
  readonly slug: string
  /** Site da empresa (SS-01). A Api sempre inclui o campo (string ou null); opcional aqui por tolerancia. */
  readonly website?: string | null
  readonly status: string
  readonly createdAt: string
}

export interface MembershipResponse {
  readonly id: string
  readonly userId: string
  readonly role: string
  readonly status: string
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function isUserResponse(value: unknown): value is UserResponse {
  return (
    isRecord(value) &&
    typeof value['id'] === 'string' &&
    typeof value['email'] === 'string' &&
    typeof value['displayName'] === 'string'
  )
}

export function isTenantResponse(value: unknown): value is TenantResponse {
  return (
    isRecord(value) &&
    typeof value['id'] === 'string' &&
    typeof value['name'] === 'string' &&
    typeof value['slug'] === 'string' &&
    (value['website'] === null ||
      value['website'] === undefined ||
      typeof value['website'] === 'string') &&
    typeof value['status'] === 'string' &&
    typeof value['createdAt'] === 'string'
  )
}

export function isTenantResponseArray(value: unknown): value is readonly TenantResponse[] {
  return Array.isArray(value) && value.every(isTenantResponse)
}

export function isMembershipResponse(value: unknown): value is MembershipResponse {
  return (
    isRecord(value) &&
    typeof value['id'] === 'string' &&
    typeof value['userId'] === 'string' &&
    typeof value['role'] === 'string' &&
    typeof value['status'] === 'string'
  )
}

export function isMembershipResponseArray(value: unknown): value is readonly MembershipResponse[] {
  return Array.isArray(value) && value.every(isMembershipResponse)
}
